// extracted by mini-css-extract-plugin
export default {"dangerInput":"styles_dangerInput__3r_0F","fullWidth":"styles_fullWidth__H1j1m"};